import {
  updateDoc,
  doc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

import {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  createUser,
  deleteUser,
} from '../slices/usersSlice';
import { setOnboardingComplete, setUserProfileImage } from '../slices/currentUserSlice';

import { db } from "../../firebase";

// import usersData from '../../jsons/users.json';

export const fetchUsers = () => async (dispatch) => {
  try {
    dispatch(fetchUsersStart());
    setTimeout(() => {
      // dispatch(fetchUsersSuccess(usersData));
    }, 500);
  } catch (error) {
    dispatch(fetchUsersFailure(error.message));
  }
};

export const createNewUser = (newUser) => async (dispatch) => {
  try {
    const response = await new Promise((resolve) =>
      setTimeout(() => {
        resolve({ ...newUser, id: Date.now().toString() });
      }, 500)
    );

    dispatch(createUser(response));
  } catch (error) {
    console.error('Error creating user:', error);
  }
};

export const updateExistingUser = (employeeId, updatedUser) => async (dispatch) => {
  try {
    dispatch(fetchUsersStart());
    const userRef = doc(db, "employees", employeeId);
    await updateDoc(userRef, updatedUser);

    // If we're updating profile image
    if (updatedUser.profileImageUrl) {
      dispatch(setUserProfileImage(updatedUser));
      dispatch(setOnboardingComplete());
    }

    dispatch(fetchUsersSuccess());
  } catch (error) {
    dispatch(fetchUsersFailure(error.message));
  }
};


// Function to upload an image to the Firebase Storage bucket
export const uploadImageToStorage = async (file, employeeId) => {
  const storage = getStorage(); // Inicializar Firebase Storage

  if (!file) {
    throw new Error("No file provided.");
  }

  // Make this path/filename consistent to previous impl..
  const storageRef = ref(storage, `profile-photos/${employeeId}`);

  // Upload the file to the bucket
  await uploadBytes(storageRef, file);

  // Get the public URL for the uploaded file
  const downloadURL = await getDownloadURL(storageRef);

  return downloadURL;// Return the URL
};

export const deleteExistingUser = (id) => async (dispatch) => {
  try {
    await new Promise((resolve) => setTimeout(resolve, 500));

    dispatch(deleteUser(id));
  } catch (error) {
    console.error('Error deleting user:', error);
  }
};
